import Tooltip from '@material-ui/core/Tooltip';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import { isPalletOnlyProduct, ShoppingCartSubject } from '../../api/shoppingCart';
import useTranslateWithFallback from '../../hooks/useTranslateWithFallback';
import { PalletIcon } from './shipmentIcons';

export interface CartShipmentPalletOnlyMarkProps {
  className?: string;
  product: ShoppingCartSubject['product'];
}

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 8px',
        borderRadius: 12,
        backgroundColor: theme.palette.appBar.background,
        color: theme.palette.primary.main,
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.4,
        whiteSpace: 'nowrap',
        cursor: 'default',
      },
      icon: {
        fontSize: 16,
        marginRight: 4,
      },
    }),
  { name: 'CartShipmentPalletOnlyMark' },
);

/**
 * Marks cart item that can be transported on a pallet only, so the whole cart goes as a pallet.
 */
const CartShipmentPalletOnlyMark: React.FC<CartShipmentPalletOnlyMarkProps> = ({ className, product }) => {
  const classes = useStyles();
  const t = useTranslateWithFallback();

  if (!isPalletOnlyProduct(product)) return null;

  return (
    <Tooltip arrow title={t('shoppingCart/shipment/palletOnlyProductHint')}>
      <span className={clsx(classes.root, className)}>
        <PalletIcon className={classes.icon} />
        {t('shoppingCart/shipment/palletOnlyProduct')}
      </span>
    </Tooltip>
  );
};

CartShipmentPalletOnlyMark.displayName = 'CartShipmentPalletOnlyMark';

export default CartShipmentPalletOnlyMark;
